import GeneralLayout from "@/layouts/General"
import { cEsSubMenus } from "@/app/utils/constants"
import NavBorder from "@/assets/imgs/our-story/nav-border.png"
import NavBgBorder from "@/assets/imgs/our-story/nav-bg-border.webp"
import NavBorderSeparator from "@/assets/imgs/our-story/nav-border-separator.png"
import { useGlobalContext } from "@/global/GlobalContext"
import CenteredHero from "@/components/CenteredHero"
import ContentMAPI from "@/app/api/content-management/content-management"
import { useEffect, useRef, useState } from "react"
import clsx from "clsx"
import { LoadButton } from "@/components/Button"
import { EventCards } from "@/components/event-card/EventCard"
import EventCardSkeleton from "@/components/skeletons/EventCardSkeleton"
import { useSearchParams } from "react-router-dom"
const contentMApi = new ContentMAPI()

const CulturalEvent = () => {
  const { notifyError, locSearch, pathname } = useGlobalContext()
  const [timeType, setTimeType] = useState(1)
  const [culturalEvs, setCulturalEvs] = useState([])
  const [currCulturalEvs, setCurrCulturalEvs] = useState([])
  const [allLoaded, setAllLoaded] = useState(false)
  const [loadedImgs, setLoadedImgs] = useState(0)
  const [tempCulturalEvsL, setTempCulturalEvsL] = useState(0)
  const [hideLoadMoreBtn, setHideLoadMoreBtn] = useState(true)
  const [onReq, setOnReq] = useState(true)
  const [page, setPage] = useState(1)
  const [searchParams, setSearchParams] = useSearchParams()
  const isChangeSubPage = useRef(false)
  const isChangePage = useRef(false)

  useEffect(() => {
    const activeStatus = new URLSearchParams(locSearch).get("slug")

    if (activeStatus) {
      let selected = 1
      switch (activeStatus) {
        case "past-events":
          selected = 0
          break;
        default:
          selected = 1
          break;
      }

      loadCulturalEvs(selected)
      setTimeType(selected)
    } else {
      loadCulturalEvs()
    }
  }, [])

  useEffect(() => {
    if (loadedImgs == cEsSubMenus.length) setAllLoaded(true)
  }, [loadedImgs])

  useEffect(() => {
    if (culturalEvs.length > currCulturalEvs.length) {
      setCurrCulturalEvs(culturalEvs)
    }

    handleLoadMoreBtn(timeType)
  }, [culturalEvs])

  useEffect(() => {
    setCurrCulturalEvs([])
    setPage(1)
  }, [timeType])

  useEffect(() => {
    // trigger when I change sub page
    if (currCulturalEvs.length == 0 && isChangePage.current) {
      loadCulturalEvs()
    }
  }, [currCulturalEvs])

  useEffect(() => {
    if (page > 1) loadCulturalEvs()
  }, [page])

  const loadMoreEvents = () => {
    setPage(page + 1)
  }

  const changeSubpage = (time_type) => {
    isChangePage.current = true
    isChangeSubPage.current = true
    if (timeType != time_type) {
      setTimeType(time_type)
      const activeStatus = cEsSubMenus.find(val => val.time_type == time_type)
      setSearchParams({ slug: activeStatus.slug })
    }
  }

  const handleLoadMoreBtn = () => {
    setHideLoadMoreBtn(culturalEvs.length < 5)
  }

  const handleImageLoad = () => {
    setLoadedImgs((prev) => typeof prev === "number" ? prev + 1 : 1)
  }

  // API request
  const loadCulturalEvs = async (currTimeType = timeType) => {
    setOnReq(true)
    try {
      let params = {
        page: page,
        time_type: currTimeType,
      }
      const { data } = await contentMApi.getCulturalEvs(params)
      setTempCulturalEvsL(data.data.culturalEvents.length)

      if (currTimeType != timeType) setTimeType(currTimeType)

      if (page > 1) {
        setCulturalEvs(currCulturalEvs.concat(data.data.culturalEvents))
      } else {
        setCulturalEvs(data.data.culturalEvents)
      }
    } catch (err) {
      notifyError(err.message)
    }
    setOnReq(false)
  }

  return (
    <GeneralLayout bgColor="bg-white" isFixed={false}>
      <CenteredHero title="Cultural Events" custCls="bg-[url('/src/assets/imgs/cultural-event/banner.jpeg')] h-[60vh]" />
      <ul className={clsx("flex mx-auto flex-row-reverse w-[45%] lg:w-[30%] 2xl:w-1/4 relative mt-5 sm:mt-10 mb-2.5 sm:mb-5", { "gap-1 h-6 sm:h-10": !allLoaded })}>
        {allLoaded &&
          <img width="40" src={NavBorderSeparator} className="absolute top-0 left-1/2 -translate-x-1/2 w-[22px] sm:w-[40px] md:w-[50px] lg:w-[45px] xl:w-[55px]" />
        }
        {cEsSubMenus.map((d, i) => (
          i < 2 && (
            <li key={i} className={clsx({ "w-full animate-shimmer transition-opacity bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200": !allLoaded })}>
              <div className={clsx("flex justify-center items-center px-1 pt-[1px] lg:pt-0.5 relative", { "hidden": !allLoaded })}>
                <img width="100" src={NavBorder} onLoad={handleImageLoad} className="w-full" />
                {timeType == d.time_type && (
                  <img width="100" src={NavBgBorder} className="w-full absolute" />
                )}
                <button type="button" onClick={() => changeSubpage(d.time_type)} className="absolute max-lg:top-[5px] text-[10px] sm:text-xl font-agcasmlt font-extralight tracking-wide text-charcoal-black">{d.name}</button>
              </div>
            </li>
          )
        ))}
      </ul>
      <section className="w-full bg-[url('/src/assets/imgs/cultural-event/section-cover.webp')] bg-cover no-repeat bg-center py-10 sm:py-20 px-6 sm:px-12">
        {onReq ? (
          currCulturalEvs.length <= 0 ?
            <EventCardSkeleton />
            :
            <EventCards pathname={pathname} events={currCulturalEvs} hasLocation hasSchedule onReq={onReq} />
        ) : (
          currCulturalEvs?.length > 0 ?
            <EventCards pathname={pathname} events={currCulturalEvs} hasLocation hasSchedule onReq={onReq} />
            :
            <p className="text-center text-gray-500">No cultural event available.</p>
        )}
        {(!hideLoadMoreBtn && tempCulturalEvsL >= 5) && (
          <div className="py-8 text-center">
            <LoadButton onClickBtn={loadMoreEvents} />
          </div>
        )}
      </section>
    </GeneralLayout>
  )
}

export default CulturalEvent